/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Stats_CitizensInputs */

const en_home_stats_citizens = /** @type {(inputs: Home_Stats_CitizensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`of citizens want AI to be slowed down by our governments`)
};

/**
* | output |
* | --- |
* | "of citizens want AI to be slowed down by our governments" |
*
* @param {Home_Stats_CitizensInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_stats_citizens = /** @type {((inputs?: Home_Stats_CitizensInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Stats_CitizensInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_stats_citizens(inputs)
});